import '@ox-technologies/ui/styles';
import './styles.css';
import 'utils/localization/i18n';

import { RouterProvider } from '@tanstack/react-router';
import ErrorFallback from 'components/error-fallback/error-fallback';
import React from 'react';
import ReactDOM from 'react-dom/client';
import { ErrorBoundary } from 'react-error-boundary';
import AuthProvider from 'utils/auth/auth-provider';
import QueryClientProvider from 'utils/gql/query-client-provider';
import { router } from 'utils/routing/router';

ReactDOM.createRoot(document.getElementById('root') as HTMLElement).render(
  <React.StrictMode>
    <QueryClientProvider>
      <ErrorBoundary FallbackComponent={ErrorFallback}>
        <AuthProvider>
          <RouterProvider router={router} />
        </AuthProvider>
      </ErrorBoundary>
    </QueryClientProvider>
  </React.StrictMode>
);
